<div class="vehicle-status-filter">
  <mat-form-field appearance="outline" color="accent">
    <mat-select
      defaultText="Select an option"
      i18n-defaultText="@@S_SELECTANOPTION"
      (selectionChange)="onStatusFilterChange($event)"
      [value]="statusFilterSelected"
      a7s-id="live-map-options-filter"
      panelClass="mat-select-dropdown-centered mat-select-status-filters"
      disableOptionCentering="true"
    >
      <ng-container>
        <mat-option [value]="EVehicleStatusType.All" a7s-id="live-map-options-filter-all-vehicles" i18n="@@S_STATUS_FILTER_ALL_STATUSES_X"
          >All statuses ({{ statusCounts?.get(EVehicleStatusType.All) }})</mat-option
        >
        <mat-option [value]="EVehicleStatusType.Moving" a7s-id="live-map-options-filter-moving-vehicles" i18n="@@S_STATUS_FILTER_MOVING_X"
          >Moving ({{ statusCounts?.get(EVehicleStatusType.Moving) }})</mat-option
        >
        <mat-option [value]="EVehicleStatusType.Idle" a7s-id="live-map-options-filter-idle-vehicles" i18n="@@S_STATUS_FILTER_IDLING_X"
          >Idling ({{ statusCounts?.get(EVehicleStatusType.Idle) }})</mat-option
        >
        <mat-option
          [value]="EVehicleStatusType.Stopped"
          a7s-id="live-map-options-filter-stopped-vehicles"
          i18n="@@S_STATUS_FILTER_STOPPED_X"
          >Stopped ({{ statusCounts?.get(EVehicleStatusType.Stopped) }})</mat-option
        >
        <mat-option
          *ngIf="showCharging"
          [value]="EVehicleStatusType.Charging"
          a7s-id="live-map-options-filter-charging-vehicles"
          i18n="@@S_STATUS_FILTER_CHARGING_X"
          >Charging ({{ statusCounts?.get(EVehicleStatusType.Charging) }})</mat-option
        >
      </ng-container>
    </mat-select>
  </mat-form-field>
</div>
